import * as React from 'react';

export const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 11.5759 16.4792 13.0302 15.6004 14.2001C15.6046 14.2033 15.6088 14.2065 15.6129 14.2097L15.7071 14.2929L19.9497 18.5355C20.3403 18.9261 20.3403 19.5592 19.9497 19.9497C19.5893 20.3102 19.022 20.338 18.6297 20.0329L18.5355 19.9497L14.2929 15.7071C14.259 15.6733 14.2281 15.6376 14.2001 15.6004C13.0302 16.4792 11.5759 17 10 17C6.13401 17 3 13.866 3 10ZM10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5Z"
      fill="#FBB600"
    />
  </svg>
);

export const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="30"
    viewBox="0 0 48 48"
    width="30"
  >
    <path
      d="M38 12.83l-2.83-2.83-11.17 11.17-11.17-11.17-2.83 2.83 11.17 11.17-11.17 11.17 2.83 2.83 11.17-11.17 11.17 11.17 2.83-2.83-11.17-11.17z"
      fill="#FBB600"
    />
  </svg>
);
